import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=0af9d042&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=0af9d042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9d042",
  null
  
)

export default component.exports